<template>
  <v-sheet>
    <v-main>
      <Header />
      <router-view></router-view>
    </v-main>
  </v-sheet>
</template>

<script>
import Header from '@/ui/shared/components/Header.vue'

export default {
  name: 'DefaultLayout',

  components: {
    Header,
  },
}
</script>
